// extracted by mini-css-extract-plugin
module.exports = {"header":"LogoutHeader_header__2jq6P","toolbar":"LogoutHeader_toolbar__3ryYL","title":"LogoutHeader_title__-Hwso"};